<script setup>
  import { computed, ref, watch } from "vue";
  import { uniqueId } from "lodash";

  const emit = defineEmits(['itemChanged']);
  const props = defineProps({
    default: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  });
  const uuid = uniqueId();
  const firstItemValue = props.items.length > 0 ? props.items[0].value : null;
  const selectedValue = ref(props.default ? props.default : firstItemValue);
  const selectedIndex = computed(() => props.items.findIndex(item => item.value === selectedValue.value));

  const hasDivider = (index) => index !== selectedIndex.value
    && index !== props.items.length - 1
    && index + 1 !== selectedIndex.value;

  watch(selectedValue, value => emit('itemChanged', value));
</script>

<template>
  <div
    class="
      tw-flex
      tw-min-h-[2.5rem]
      tw-rounded-xl
      tw-bg-everest-dark
      tw-p-1
    "
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="tw-flex tw-flex-1 tw-items-center"
    >
      <input
        :id="`${uuid}-${index}`"
        v-model="selectedValue"
        type="radio"
        :name="`${uuid}-option`"
        class="tw-peer tw-sr-only"
        :value="item.value"
      >
      <label
        :for="`${uuid}-${index}`"
        class="
          tw-relative
          tw-flex
          tw-h-full
          tw-flex-1
          tw-cursor-pointer
          tw-items-center
          tw-justify-center
          tw-rounded-lg
          tw-bg-everest-dark
          tw-p-1
          tw-text-[0.9375rem]
          tw-text-white
          peer-checked:tw-bg-everest-light
          peer-checked:tw-text-everest-dark
        "
        :class="{
          'after:tw-absolute after:tw-right-0 after:tw-h-4 after:tw-w-px after:tw-bg-everest': hasDivider(index),
          'tw-text-base tw-font-medium': selectedIndex === index,
        }"
      >
        {{ item.text }}
      </label>
    </div>
  </div>
</template>
